import { CloseCircleFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SharedIconButton } from "../shared";
interface IProps {
  selected?: string;
  formDate?: string;
  toDate?: string;
  handleClearSearch?: () => void;
  handleClearDate?: () => void;
}
export const SelectedFilter = ({
  selected,
  formDate,
  toDate,
  handleClearSearch,
  handleClearDate,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <StyledFilter>
      <p>{t("page.filter_by")}</p>
      <div className="selected">
        {selected && (
          <div className="item">
            <p>{selected}</p>
            <button className="icon" onClick={handleClearSearch}>
              <CloseCircleFilled />
            </button>
          </div>
        )}
        {formDate && (
          <div className="item">
            <p>{formDate}</p>
          </div>
        )}
        {toDate && <span>{t("page.to")}</span>}
        {toDate && (
          <div className="item">
            <p>{toDate}</p>
            <button className="icon" onClick={handleClearDate}>
              <CloseCircleFilled />
            </button>
          </div>
        )}
      </div>
    </StyledFilter>
  );
};

const StyledFilter = styled.div`
  padding: 0 32px;
  display: flex;
  column-gap: 20px;
  align-items: center;
  margin-bottom: 20px;
  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #000000;
  }
  .selected {
    display: flex;
    column-gap: 20px;
    align-items: center;
    .item {
      background: rgba(240, 109, 36, 0.17);
      border-radius: 4px;
      padding: 7px 8px;
      position: relative;
      p {
        color: ${(p) => p.theme.colors.main};
      }
      .icon {
        position: absolute;
        right: -4px;
        top: -4px;
        padding: 0;
        border: 0;
        cursor: pointer;
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
`;
